import Specialization from './Specialization';

export default Specialization;
